import { Link, useLocation } from 'react-router-dom';
import classes from './Footer.module.scss';
import { useTranslation } from 'react-i18next';




  



const Breadcrumbs: React.FC = () => {
  const { t } = useTranslation();
  const pathNamesMap: Record<string, string> = {
    'about': t('common:header.feature'),
     'student-club': t('common:header.studentclub'),
     'usage-ex': t('common:header.usageex'),
     'news': t('common:header.news'),
     'interview': t('common:header.interviews'),
     'research-result': t('common:header.research-result'),
     'post': 'POST',
     'school-list': t('common:header.school-list'),
   };
 
   const excludedSegments = ['ja', 'en', 'zh'];  

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x && !excludedSegments.includes(x));

  return (
    <div className={classes.breadcrumbs}>
      <Link to="/">Home</Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const readableText = pathNamesMap[value] || value;

        return (
          <span key={to}>
            ＞ <Link to={to}>{readableText}</Link>
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
